import { createContext, useContext } from "react";
import PropTypes from "prop-types";

export const DecisionContext = createContext();

function DecisionProvider({ value, children }) {
	return <DecisionContext.Provider value={value}>{children}</DecisionContext.Provider>;
}

DecisionProvider.propTypes = {
	value: PropTypes.any,
	children: PropTypes.node.isRequired,
};

function useDecisionContext() {
	return useContext(DecisionContext);
}

export { DecisionProvider, useDecisionContext };
